import { render, staticRenderFns } from "./user-quote-main.vue?vue&type=template&id=6e467fd0&"
import script from "./user-quote-main.vue?vue&type=script&lang=js&"
export * from "./user-quote-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports